// extracted by mini-css-extract-plugin
module.exports = {"multi-value":"style_multi-value__KY1lH","multi-value-text":"style_multi-value-text__peZ2L","multi-value-remove":"style_multi-value-remove__YDrJt"};